export enum OttopilotExternalSourceWorkspaceCapabilityAccessOperation {
    create = "4ee49388-69cd-4f96-871b-49f5a11f4446",
    read = "7face960-dc24-45fc-9522-784d219fcb88",
    update = "f04c08f3-18ba-4806-be22-19b396229884",
    delete = "79c7f423-e159-4b10-ba18-7db7d546ace0",
}
